/**
 * Generated bundle index. Do not edit.
 */

export {AdsenseConfig,ADSENSE_CONFIG,AdsenseComponent,AdsenseModule} from './ng2-adsense';
